<template>
  <card :modifier-classes="['card--v card--skeleton']" :target="link.url">
    <template v-slot:card-content>
      <h3>{{ title }}</h3>
      <p class="lead-text">{{ text }}</p>
    </template>
    <template v-if="link.url" v-slot:card-action>
      <prismic-link class="btn btn-primary btn--large" :field="link">{{ KriensTourismus.languageKeys['read-more'] }}</prismic-link>
    </template>
  </card>
</template>

<script>
import Card from '../../elements/Card.vue'

export default {
  name: "Good2KnowItem",
  components: {
    Card
  },
  props: ["title", "text", "link"]
};
</script>
